import React, { Component, useState } from "react";
import $ from "jquery";
import { ToastContainer } from "react-toastify";
import toast from "../helpers/toast";
import Httpconfig from "../helpers/HttpconfigDiagnostics";
import Constant from "../../constants";
import { MDBDataTable } from "mdbreact";
import { Link } from "react-router-dom";
import RetailerCss from "../../public/css/retailer/retailer_style.css";
import DiagnosisHeader from "../diagnostics/DiagnosisHeader";
import DiagnosisMenu from "../diagnostics/DiagnosisMenu";
import Footer from "../patient/Patientfooter";
import { Multiselect } from "multiselect-react-dropdown";
import { reactLocalStorage } from "reactjs-localstorage";
import ReactExport from "react-data-export";
import dateformatter from "../helpers/dateformatter";
import * as SecureLS from "secure-ls";
var ls = new SecureLS({
  encodingType: "aes",
  encryptionSecret: "medleymed",
});

const ExcelFile = ReactExport.ExcelFile;
const ExcelSheet = ReactExport.ExcelFile.ExcelSheet;
const ExcelColumn = ReactExport.ExcelFile.ExcelColumn;

export default class DiagnosisTest extends Component {
  constructor(props) {
    super(props);
    this.state = {
      fields: {},
      errors: {},
      availableHome: "nav-item nav-link active",
      runningHome: "nav-item nav-link",
      outHome: "nav-item nav-link",
      expireHome: "nav-item nav-link",
      orderHome: "nav-item nav-link order_book_item ord_med_btn",

      currentHomePanel: "tab-pane fade",
      availableHomePanel: "tab-pane fade",
      runningHomePanel: "tab-pane fade show",
      outHomePanel: "tab-pane fade",
      expireHomePanel: "tab-pane fade",
      selelcteTestId: "",
      medicineOptions: "",
      medicineArray: [],
      selectedMedicineList: {},
      selectedMedicineValue: [],
      // Package test related states
      packageTestsData: [], // Master data filtered for tests only
      selectedPackageTests: [], // Selected tests for package
      showPackageTestsDropdown: false, // Show/hide package tests dropdown
      addMedicineSection: "collapse-hide",
      requestbtn: "request_btn collapse-hide",
      updatebtn: "update_btn collapse-show",
      productUpdatebtn: "update_btn collapse-hide",
      showfields: "col-md-12 collapse-show",
      finalOrder: "collapse-hide",
      retailerCurrentMedicineDetailsView: "",
      retailerLowStockCurrentMedicineDetailsView: "",
      retailerNoStockCurrentMedicineDetailsView: "",
      retailerExpiredStockCurrentMedicineDetailsView: "",
      retailerShortagebookProductsList: "",
      retailerFinalOrderMedicineDetailsView: "",
      shortageBookItemsCount: "0",

      totalAvailableStock: "0",
      totalLowStock: "0",
      totalOutofStock: "0",
      totalExpiredStock: "0",
      totalShortagebookStock: "0",
      showFinalOrderButton: "total_items collapse-hide",
      exportproductsarray: [],
      search: "",
      alphabetListView: "",
      searchType: "medicine_search",
      searchInput: "input-group col-md-8",
      searchDownload: "col-md-4 download_xls no_padding",
      retailerDetails: [],
    };
    this.fetchmedicinedata = this.fetchmedicinedata.bind(this);
    this.retailerProductsList = this.retailerProductsList.bind(this);
    this.retailerLowStockProductsList = this.retailerLowStockProductsList.bind(
      this
    );
    this.retailerExpiredStockProductsList = this.retailerExpiredStockProductsList.bind(
      this
    );
    this.retailerShortagebookProductsList = this.retailerShortagebookProductsList.bind(
      this
    );
    this.addFinalList = this.addFinalList.bind(this);
  }
  // To get detais after first render
  componentDidMount = () => {
    $(function() {
      var dtToday = new Date();
      var month = dtToday.getMonth() + 1;
      var day = dtToday.getDate();
      var year = dtToday.getFullYear();
      if (month < 10) month = "0" + month.toString();
      if (day < 10) day = "0" + day.toString();

      var minDate = year + "-" + month + "-" + day;

      $("#txtDate").attr("min", minDate);
    });

    let userData = ls.get("diagnosticsuserObj");
    if (userData) {
      if (userData != "") {
        this.setState({
          retailerId: userData.diagnosis_id,
        });
        this.forceUpdate();
      }
    } else {
      window.location.href = "/login";
    }

    this.getAllDashboardDetails(userData.diagnosis_id);
    this.alphabetList("available_home-li");
    this.getRetailerDetails(userData.diagnosis_id);
    this.retailerProductsList(userData.diagnosis_id);
  };
  // print alphabets
  alphabetList = (id) => {
    const letters = [..."ABCDEFGHIJKLMNOPQRSTUVWXYZ"];

    const alphaDetailsView = letters.map((finalLoadedData, num) => {
      return (
        <li
          class="alpha-list"
          id={finalLoadedData}
          onClick={this.searchProduct}
        >
          {finalLoadedData}
        </li>
      );
    });
    this.state.alphabetLists = alphaDetailsView;
  };

  // Get the Retailer Details
  getRetailerDetails = (retailerId) => {
    Httpconfig.httptokenget(Constant.siteurl + "api/diagnosis/" + retailerId)
      .then((response) => {
        if ((response.data.status = 200 && !response.data.error)) {
          this.setState({ retailerDetails: response.data.data[0] });
          this.retailerProductsList(retailerId);
        }
      })
      .catch((error) => {
        toast.error(error);
      });
  };

  // Get the Stock Details
  getAllDashboardDetails = (retailerId) => {
    Httpconfig.httptokenget(
      Constant.siteurl +
        "api/DIAGNOSIS/diagnosisProduct/dashboardStockDetails/" +
        retailerId
    )
      .then((response) => {
        if ((response.data.status = 200)) {
          this.setState({
            // Don't override totalAvailableStock as it's now correctly set from the actual tests list
            // totalAvailableStock: response.data.data[0].availiableStock,
            totalLowStock: response.data.data[0].runningLow,
            totalOutofStock: response.data.data[0].outOfStock,
            totalExpiredStock: response.data.data[0].expiredStock,
            totalShortagebookStock: response.data.data[0].orderBookedStock,
          });
          this.forceUpdate();
        }
      })
      .catch((error) => {
        toast.error(error);
      });
  };
  //    Cliking on the tab
  handleClick = (event) => {
    let id = event.currentTarget.id;
    let retailerId = this.state.retailerId;
    this.state.availableHome = "nav-item nav-link ";
    this.state.runningHome = "nav-item nav-link";
    this.state.outHome = "nav-item nav-link";
    this.state.expireHome = "nav-item nav-link";
    this.state.orderHome = "nav-item nav-link order_book_item ord_med_btn";

    this.state.currentHomePanel = "tab-pane fade";
    this.state.availableHomePanel = "tab-pane fade";
    this.state.runningHomePanel = "tab-pane fade show";
    this.state.outHomePanel = "tab-pane fade";
    this.state.expireHomePanel = "tab-pane fade";

    this.state.addMedicineSection = "collapse-hide";
    this.state.otherSection = "tab-content collapse-show";
    this.state.finalOrder = "collapse-hide";
    this.state.searchDownload = "col-md-4 download_xls no_padding";
    this.state.searchInput = "input-group col-md-8";

    if (id == "available_home-tab") {
      this.state.availableHome = "nav-item nav-link active";
      this.state.availableHomePanel = "tab-pane fade show active";
      this.retailerProductsList(retailerId);
      this.alphabetList("available_home-li");
      this.state.searchType = "medicine_search";
    }
    if (id == "running_home-tab") {
      this.state.runningHome = "nav-item nav-link active";
      this.state.runningHomePanel = "tab-pane fade show active";
      this.retailerLowStockProductsList(retailerId);
      this.alphabetList("running_home-li");
      this.state.searchType = "low_stock";
    }
    if (id == "Expire_home-tab") {
      this.state.expireHome = "nav-item nav-link active";
      this.state.expireHomePanel = "tab-pane fade show active";
      this.retailerExpiredStockProductsList(retailerId);
      this.alphabetList("Expire_home-li");
      this.state.searchType = "expiry_stock";
    }
    if (id == "out_home-tab") {
      this.state.outHome = "nav-item nav-link active";
      this.state.outHomePanel = "tab-pane fade show active";
      this.retailerOutStockProductsList(retailerId);
      this.alphabetList("out_home-li");
      this.state.searchType = "empty_stock";
    }

    if (id == "order_home-tab") {
      this.state.orderHome =
        "nav-item nav-link order_book_item ord_med_btn active ";
      this.state.orderHomePanel = "tab-pane fade show active";
      this.state.searchDownload =
        "col-md-offset-8 col-md-4 download_xls no_padding";
      this.state.searchInput = "input-group col-md-8 collapse-hide";
      this.retailerShortagebookProductsList(retailerId);
      this.alphabetList("order_home-li");
    }

    this.forceUpdate();
  };
  // add medicine tabs show/hide
  showAddMedicine = () => {
    this.state.addMedicineSection = "collapse-show";
    this.state.otherSection = "tab-content collapse-hide";
    this.state.availableHome = "nav-item nav-link ";
    this.state.runningHome = "nav-item nav-link";
    this.state.outHome = "nav-item nav-link";
    this.state.expireHome = "nav-item nav-link";
    this.state.orderHome = "nav-item nav-link order_book_item ord_med_btn";
    this.forceUpdate();
  };

  //  fetch master medicine data on search
  fetchmedicinedata(event) {
    let search = event.target.value;
    let medicinesList = [];
    this.state.requestbtn = "request_btn collapse-hide";
    this.state.updatebtn = "update_btn collapse-show";
    this.state.showfields = "col-md-12 collapse-show";
    this.state.search = search;
    this.setState({
      showPackageTestsDropdown: true,
    });
    if (search != "") {
      Httpconfig.httptokenget(
        Constant.siteurl + "api/DIAGNOSIS/diagnosisProduct/medicine/" + search
      ).then((response) => {
        // console.log("--256--", response);
        if (Object.keys(response.data.data).length > 0) {
          const medicineDetailsView = response.data.data.map(
            (finalLoadedData, num) => {
              return (
                <li
                  id={finalLoadedData.id}
                  onClick={this.handleChange.bind(
                    this,
                    finalLoadedData.id,
                    finalLoadedData.testname,
                    finalLoadedData.description,
                    finalLoadedData.mrp,
                    finalLoadedData.discount,
                    finalLoadedData.test_type // Pass test_type to handleChange
                  )}
                >
                  {finalLoadedData.testname}{" "}
                  {finalLoadedData.test_type === "package"
                    ? "(Package)"
                    : "(Test)"}
                </li>
              );
            }
          );
          this.state.medicineOptions = medicineDetailsView;
          this.forceUpdate();
        } else {
          this.state.requestbtn = "request_btn collapse-show";
          this.state.updatebtn = "update_btn collapse-hide";
          this.state.showfields = "col-md-12 collapse-hide";
          this.state.medicineOptions = "";
          this.forceUpdate();
        }
      });
    } else {
      this.state.medicineOptions = "";
      this.forceUpdate();
    }
  }
  //  onchanges on master search
  handleChange = (id, name, description, mrp, discount, test_type) => {
    let searched = id; //event.currentTarget.id;
    let testName = name; //event.currentTarget.innerText;

    // Set base fields
    let newFields = {
      test_description: description,
      mrp: mrp,
      discount: discount,
    };

    // If selected test is a package, automatically set TEST_TYPE to package
    if (test_type === "package") {
      newFields.TEST_TYPE = "package";

      // Load package tests for this specific package
      this.loadPackageTestsFromAPI(searched);
    } else {
      // For regular tests, set TEST_TYPE to test
      newFields.TEST_TYPE = "test";
    }

    // Only show package tests dropdown when selected test type is package
    this.setState({
      selelcteTestId: searched,
      selelcteMedicineName: testName,
      medicineOptions: "",
      fields: newFields,
      showPackageTestsDropdown: test_type === "package", // Only show for package types
      selectedPackageTests: [], // Reset selected tests
    });

    // Load general package tests data if not already loaded (for manual selection)
    if (this.state.packageTestsData.length === 0) {
      this.loadPackageTestsData();
    }

    $("#medicineList").val("");
    $("#medicineList").val(testName);
    // this.forceUpdate();
  };

  // Load package tests data (only tests, not packages) - similar to fetchmedicinedata
  loadPackageTestsData = (searchTerm = "") => {
    let apiUrl = Constant.siteurl + "api/DIAGNOSIS/diagnosisProduct/medicine/";

    // If searchTerm provided, use search API like fetchmedicinedata, else load all
    if (searchTerm && searchTerm.trim() !== "") {
      apiUrl += searchTerm;
    } else {
      apiUrl += "all"; // Load all tests for initial dropdown
    }

    Httpconfig.httptokenget(apiUrl)
      .then((response) => {
        if (Object.keys(response.data.data).length > 0) {
          // Filter only test type items (not package)
          const testTypeItems = response.data.data.filter(
            (item) => item.test_type === "test"
          );

          // Format for multiselect dropdown
          const formattedTests = testTypeItems.map((test) => ({
            id: test.id,
            name: test.testname,
            testname: test.testname,
            description: test.description,
            test_type: test.test_type,
          }));

          this.setState({ packageTestsData: formattedTests });
        } else {
          // If no tests found and it's a search, keep existing data but could show message
          if (searchTerm && searchTerm.trim() !== "") {
            // For search with no results, we'll handle this in the multiselect component
            this.setState({ packageTestsData: [] });
          }
        }
      })
      .catch((error) => {
        toast.error("Error loading tests data");
      });
  };

  // Search function specifically for package tests (similar to fetchmedicinedata)
  searchPackageTests = (searchTerm) => {
    if (searchTerm && searchTerm.trim() !== "") {
      this.loadPackageTestsData(searchTerm);
    } else {
      // Load all tests when search is cleared
      this.loadPackageTestsData();
    }
  };

  // Load package tests from API based on package ID
  loadPackageTestsFromAPI = (packageId) => {
    Httpconfig.httptokenget(
      Constant.siteurl +
        "api/DIAGNOSIS/diagnosisProduct/package-tests/" +
        packageId
    )
      .then((response) => {
        if (response.data.status === 200 && !response.data.error) {
          if (response.data.data && response.data.data.length > 0) {
            // Format the tests data for multiselect dropdown
            const formattedTests = response.data.data.map((test) => ({
              id: test.id,
              name: test.testname,
              testname: test.testname,
              description: test.description,
              test_type: test.test_type,
            }));

            // Update both packageTestsData for dropdown and selectedPackageTests for pre-selection
            this.setState({
              packageTestsData: formattedTests,
              selectedPackageTests: formattedTests, // Pre-select all tests for this package
            });

            toast.success(
              `Loaded ${formattedTests.length} tests for this package`
            );
          } else {
            // No tests found for this package
            this.setState({
              packageTestsData: [],
              selectedPackageTests: [],
            });
            toast.info("No tests found for this package");
          }
        } else {
          toast.error(response.data.message || "Error loading package tests");
          this.setState({
            packageTestsData: [],
            selectedPackageTests: [],
          });
        }
      })
      .catch((error) => {
        console.error("Error loading package tests:", error);
        toast.error("Error loading package tests");
        this.setState({
          packageTestsData: [],
          selectedPackageTests: [],
        });
      });
  };

  // input changes  handle

  handleChangeInput = (field, event) => {
    if (field == "expireDate") {
      let expDate = event.target.value;
      let count = expDate.search("-");
      if (count > 0) {
        let dateString = expDate.split("-");
        if (dateString[0].length != 4) {
          toast.error("Invalid expired date");
          return;
        }
      }
    }

    let fields = this.state.fields;
    fields[field] = event.target.value;

    // Handle test type selection for package tests
    if (field === "TEST_TYPE" && event.target.value === "package") {
      this.setState({
        showPackageTestsDropdown: true,
        selectedPackageTests: [], // Reset selected tests when switching to package
      });
      // Load package tests data if not already loaded
      if (this.state.packageTestsData.length === 0) {
        this.loadPackageTestsData();
      }
    } else if (field === "TEST_TYPE" && event.target.value !== "package") {
      // Hide when test type is not package (including "test" and empty)
      this.setState({
        showPackageTestsDropdown: false,
        selectedPackageTests: [], // Reset selected tests when switching away from package
      });
    }

    this.setState({ fields });
    this.state.errors[field] = "";
  };

  // Handle package tests selection in multiselect dropdown
  handlePackageTestsSelect = (selectedList, selectedItem) => {
    this.setState({ selectedPackageTests: selectedList });
  };

  // Handle package tests removal in multiselect dropdown
  handlePackageTestsRemove = (selectedList, removedItem) => {
    this.setState({ selectedPackageTests: selectedList });
  };

  //  add medicine submit

  checkAddMedicineSubmit(event) {
    event.preventDefault();
    const { handle } = this.props.match.params;
    if (this.handleValidation() && handle == undefined) {
      this.AddMedicineDetails(event);
    } else {
      toast.warn("Form has errors.");
    }
  }

  //  add medicine validation

  handleValidation() {
    let fields = this.state.fields;
    let errors = {};
    let formIsValid = true;
    var pattern = /^[0-9]{3,20}$/g;
    //     if (!fields["batchNumber"] || fields["batchNumber"] == 0) {
    //       errors["batchNumber"] = "";
    //       formIsValid = false;
    //       errors["batchNumber"] = "Enter batch number";
    //     }
    //     if (!Number(fields["qty"])) {
    //       errors["qty"] = "";
    //       formIsValid = false;
    //       errors["qty"] = "Enter Quantity";
    //     }
    // if (!fields["product_name"]) {
    //   errors["product_name"] = "";
    //   formIsValid = false;
    //   errors["product_name"] = "Enter Test Name";
    // }
    if (!Number(fields["mrp"])) {
      errors["mrp"] = "";
      formIsValid = false;
      errors["mrp"] = "Enter MRP";
    }

    if (!fields["discount"]) {
      errors["discount"] = "";
      formIsValid = false;
      errors["discount"] = "Enter Discount";
    }
    // if (!fields["GSTAmt"]) {
    //   errors["GSTAmt"] = "";
    //   formIsValid = false;
    //   errors["GSTAmt"] = "Enter GSTAmt";
    // }
    // if (parseFloat(this.state.fields["GSTAmt"]) > 50) {
    //   errors["GSTAmt"] = "";
    //   formIsValid = false;
    //   errors["GSTAmt"] = "Invalid GST";
    // }

    //     if (!fields["expireDate"]) {
    //       errors["expireDate"] = "";
    //       formIsValid = false;
    //       errors["expireDate"] = "Enter expiry date";
    //     }
    //     if (!fields["test_description"]) {
    //       errors["test_description"] = "";
    //       formIsValid = false;
    //       errors["test_description"] = "Enter Description";
    //     }
    if (this.state.selelcteTestId == "") {
      errors["selectedMedicine"] = "";
      formIsValid = false;
      errors["selectedMedicine"] = "Select Test";
    }
    this.setState({ errors: errors });
    return formIsValid;
  }

  //  add medicine data

  AddMedicineDetails = () => {
    // if (!this.state.retailerDetails["gst_type"]) {
    //   toast.error("Select GST type in settings screen");
    //   return;
    // }
    let finalGst = 0;
    let finalCgst = 0;
    let gstType = this.state.retailerDetails["gst_type"];
    if (gstType == "GST") finalGst = this.state.fields["GSTAmt"] / 2;
    else finalCgst = this.state.fields["GSTAmt"];

    // Prepare test_ids array for package type tests
    let testIds = [];
    if (
      this.state.fields.TEST_TYPE === "package" &&
      this.state.selectedPackageTests.length > 0
    ) {
      testIds = this.state.selectedPackageTests.map((test) => test.id);
    }

    Httpconfig.httptokenpost(
      Constant.siteurl + "api/DIAGNOSIS/diagnosisProduct",
      {
        retailer_id: this.state.retailerId,
        medicine_id: this.state.selelcteTestId,
        batch: "",
        expiry_date: "",
        quantity: "100",
        mrp: this.state.fields["mrp"],
        form: "",
        discount: this.state.fields["discount"],
        vat: "0",
        commission: "0",
        CGST: finalGst,
        SGST: finalGst,
        IGST: finalCgst,
        test_type: this.state.fields.TEST_TYPE || "test",
        test_ids: testIds, // Include test_ids array for package relationships
        description: this.state.fields.test_description || "",
      }
    )
      .then((response) => {
        if (response.data.status == 200 && !response.data.error) {
          document.getElementById("addMedicines").reset();
          toast.success(response.data.message);
        } else {
          toast.error(response.data.message);
        }
      })
      .catch((error) => {
        toast.error(error);
      });
  };

  //  clear all add medicine data

  clearAll = () => {
    document.getElementById("addMedicines").reset();
    // Clear package tests related state
    this.setState({
      selectedPackageTests: [],
      showPackageTestsDropdown: false,
      fields: {},
      errors: {},
    });
  };

  clearSearch = () => {
    $("#medicineList").val("");
    this.state.selelcteTestId = "";
    this.state.selelcteMedicineName = "";
  };

  //  preview shortage book data

  previewOrder = () => {
    this.state.finalOrder = "collapse-show";
    this.state.otherSection = "tab-content collapse-hide";
    this.retailerFinalOrderDetails();
    this.forceUpdate();
  };

  // Back show Order Book

  showOrderBook = () => {
    this.state.finalOrder = "collapse-hide";
    this.state.otherSection = "tab-content collapse-show";

    this.forceUpdate();
  };

  // final order details list

  retailerFinalOrderDetails = () => {
    let retailerId = this.state.retailerId;
    let finalorderarray = [];
    Httpconfig.httptokenget(
      Constant.siteurl +
        "api/DIAGNOSIS/diagnosisProduct/retailer/finalorder/" +
        retailerId
    )
      .then((response) => {
        if ((response.data.status = 200)) {
          if (Object.keys(response.data.data).length > 0) {
            const retailerFinalOrderMedicineDetailsView = response.data.data.map(
              (finalLoadedData, num) => {
                finalorderarray.push({
                  name: finalLoadedData.diagnosis_products_master_tbl.testname,
                  manufacturer:
                    finalLoadedData.diagnosis_products_master_tbl.manufacturer,
                  quantity: finalLoadedData.quantity,
                });
                return (
                  <div class="final_item">
                    <div class="row">
                      <div class="col-md-6">
                        <div class="item_list">
                          <h4>
                            {
                              finalLoadedData.diagnosis_products_master_tbl
                                .testname
                            }{" "}
                            {finalLoadedData.diagnosis_products_master_tbl.form}
                          </h4>
                          <h6>
                            {
                              finalLoadedData.diagnosis_products_master_tbl
                                .manufacturer
                            }
                          </h6>
                        </div>
                      </div>
                      <div class="col-md-6">
                        <div class="strip_list">
                          <p>{finalLoadedData.quantity}</p>
                        </div>
                      </div>
                    </div>
                  </div>
                );
              }
            );

            this.state.retailerFinalOrderMedicineDetailsView = retailerFinalOrderMedicineDetailsView;
            this.state.finalorderarray = finalorderarray;
            this.forceUpdate();
          }
        }
      })
      .catch((error) => {
        toast.error(error);
      });
  };

  // Retailers Mapped Products List

  retailerProductsList = (retailerId) => {
    Httpconfig.httptokenget(
      Constant.siteurl +
        "api/DIAGNOSIS/diagnosisProduct/retailer/" +
        retailerId,
      {}
    )
      .then((response) => {
        if (response.status == 200) {
          console.log(
            "-------553-----",
            Object.keys(response.data.data).length
          );
          // Update the available tests count with the actual count from the fetched list
          this.setState({
            totalAvailableStock: Object.keys(
              response.data.data
            ).length.toString(),
          });

          if (Object.keys(response.data.data).length > 0) {
            let retailerCurrentMedicineDetailsView = this.loadProductsData(
              response.data.data
            );
            this.setState({
              retailerCurrentMedicineDetailsView: [],
            });
            this.state.retailerCurrentMedicineDetailsView = retailerCurrentMedicineDetailsView;
            this.forceUpdate();
          } else {
            // Clear the tests list when no tests are available
            this.setState({
              retailerCurrentMedicineDetailsView: [],
            });
            this.forceUpdate();
          }
        }
      })
      .catch((error) => {
        toast.error(error);
      });
  };
  // Retailer Low stock Prodcuts List
  retailerLowStockProductsList = (retailerId) => {
    Httpconfig.httptokenget(
      Constant.siteurl +
        "api/DIAGNOSIS/diagnosisProduct/retailer/lowStock/" +
        retailerId,
      {}
    )
      .then((response) => {
        if (response.status == 200) {
          if (Object.keys(response.data.data).length > 0) {
            const retailerLowStockCurrentMedicineDetailsView = response.data.data.map(
              (finalLoadedData, num) => {
                if (
                  Object.keys(finalLoadedData.dignostic_stock_tbls).length > 0
                ) {
                  return (
                    <React.Fragment>
                      {Object.keys(finalLoadedData.dignostic_stock_tbls)
                        .length > 0
                        ? finalLoadedData.dignostic_stock_tbls.map(
                            (subData, num) => {
                              return (
                                <React.Fragment>
                                  <tr class="stock_row">
                                    {num == 0 ? (
                                      <td rowspan={num == 1 ? "2" : ""}>
                                        {finalLoadedData.diagnosis_products_master_tbl
                                          ? finalLoadedData
                                              .diagnosis_products_master_tbl
                                              .testname
                                          : "product deleted"}{" "}
                                        <h6>
                                          {finalLoadedData.diagnosis_products_master_tbl
                                            ? finalLoadedData
                                                .diagnosis_products_master_tbl
                                                .manufacturer
                                            : "manufacturer deleted"}
                                        </h6>
                                      </td>
                                    ) : (
                                      <td rowspan=""> </td>
                                    )}
                                    <td>
                                      <p>{subData.batch}</p>
                                    </td>
                                    <td>
                                      <p>
                                        {dateformatter.asianDateFormat(
                                          subData.expiry_date
                                        )}
                                      </p>
                                    </td>
                                    <td>
                                      <p>{subData.hsn ? subData.hsn : "---"}</p>
                                    </td>
                                    <td>
                                      <p>
                                        {subData.quantity} Strips{" "}
                                        {subData.quantity < 5 ? (
                                          <img
                                            class="strip_down"
                                            src="../images/patient/img/arrow-back.svg"
                                          />
                                        ) : (
                                          ""
                                        )}
                                      </p>
                                    </td>
                                    <td>
                                      <p>₹ {subData.mrp}</p>
                                    </td>
                                    {num == 0 ? (
                                      <td
                                        rowspan={num == 1 ? "2" : ""}
                                        class="input_td"
                                      >
                                        <input
                                          type="checkbox"
                                          name={"med" + subData.id}
                                          id={
                                            subData.medicine_id +
                                            "," +
                                            "0" +
                                            "," +
                                            subData.id +
                                            ",low"
                                          }
                                          onChange={this.addShortage}
                                        />
                                      </td>
                                    ) : (
                                      <td></td>
                                    )}
                                    <td>
                                      <div class="dropdown">
                                        <img
                                          onclick="myFunction()"
                                          class="edit_icon "
                                          src="../images/retailer/dottedMenu.svg"
                                        />
                                        <div
                                          class="dropdown-menu"
                                          aria-labelledby="dropdownMenuButton"
                                        >
                                          <a
                                            href="#"
                                            id={subData.medicine_id}
                                            onClick={this.getProductDetailsbyId}
                                          >
                                            <img src="../images/retailer/edit.svg" />
                                            Edit
                                          </a>
                                          <a
                                            href="#"
                                            id={subData.medicine_id}
                                            onClick={this.deleteproduct}
                                          >
                                            <img src="../images/retailer/delete.svg" />
                                            Delete
                                          </a>
                                        </div>
                                      </div>
                                    </td>
                                  </tr>
                                </React.Fragment>
                              );
                            }
                          )
                        : ""}
                    </React.Fragment>
                  );
                }
              }
            );
            this.setState({
              retailerLowStockCurrentMedicineDetailsView: [],
            });
            this.state.retailerLowStockCurrentMedicineDetailsView = retailerLowStockCurrentMedicineDetailsView;
            this.forceUpdate();
          } else {
            this.state.retailerLowStockCurrentMedicineDetailsView = "";
          }
        }
      })
      .catch((error) => {
        toast.error(error);
      });
  };

  //common function for searching and loading all products
  loadProductsData(productsData) {
    let exportproductsarray = [];
    const retailerCurrentMedicineDetailsView = productsData.map(
      (finalLoadedData, num) => {
        return (
          <React.Fragment>
            {Object.keys(finalLoadedData.dignostic_stock_tbls).length > 0
              ? finalLoadedData.dignostic_stock_tbls.map((subData, num1) => {
                  exportproductsarray.push({
                    test_id: finalLoadedData.diagnosis_products_master_tbl
                      ? finalLoadedData.diagnosis_products_master_tbl.testid
                      : "",
                    testname: finalLoadedData.diagnosis_products_master_tbl
                      ? finalLoadedData.diagnosis_products_master_tbl.testname
                      : "",
                    product_type: finalLoadedData.diagnosis_products_master_tbl
                      ? finalLoadedData.diagnosis_products_master_tbl
                          .product_type
                      : "",
                    test_type: finalLoadedData.diagnosis_products_master_tbl
                      ? finalLoadedData.diagnosis_products_master_tbl.test_type
                      : "",
                    discount: subData.discount,
                    mrp: subData.mrp,
                    description: finalLoadedData.diagnosis_products_master_tbl
                      ? finalLoadedData.diagnosis_products_master_tbl
                          .description
                      : "",
                    // GST:
                    //   this.state.retailerDetails["gst_type"] == "GST"
                    //     ? parseFloat(subData.CGST) + parseFloat(subData.SGST)
                    //     : parseFloat(subData.IGST),
                  });
                  return (
                    <React.Fragment>
                      <tr class="stock_row">
                        {num1 == 0 ? (
                          <td rowspan={num1 == 1 ? "2" : ""}>
                            {finalLoadedData.diagnosis_products_master_tbl
                              ? finalLoadedData.diagnosis_products_master_tbl
                                  .testname
                              : "product deleted"}{" "}
                            <h6>
                              {finalLoadedData.diagnosis_products_master_tbl
                                ? finalLoadedData.diagnosis_products_master_tbl
                                    .manufacturer
                                : "manufacturer deleted"}
                            </h6>
                          </td>
                        ) : (
                          <td rowspan=""></td>
                        )}

                        {/* {this.state.retailerDetails["gst_type"] == "GST" ? (
                          <td>
                            <input
                              type="text"
                              class="form-control stock_inp"
                              defaultValue={
                                parseFloat(subData.SGST) +
                                parseFloat(subData.CGST)
                              }
                              id={
                                "vat_" + subData.id + "-" + subData.medicine_id
                              }
                              name="SGST"
                              onBlur={this.handleUpdate}
                            />
                          </td>
                        ) : (
                          <td>
                            <input
                              type="text"
                              class="form-control stock_inp"
                              defaultValue={parseFloat(subData.IGST)}
                              id={
                                "vat_" + subData.id + "-" + subData.medicine_id
                              }
                              name="IGST"
                              onBlur={this.handleUpdate}
                            />
                          </td>
                        )} */}

                        <td>
                          <input
                            type="text"
                            class="form-control stock_inp"
                            defaultValue={subData.mrp}
                            data-testname={
                              finalLoadedData.diagnosis_products_master_tbl
                                ? finalLoadedData.diagnosis_products_master_tbl
                                    .testname
                                : ""
                            }
                            onKeyPress={(event) => {
                              if (!/[0-9.]/.test(event.key)) {
                                event.preventDefault();
                              }
                            }}
                            id={"mrp_" + subData.id + "-" + subData.medicine_id}
                            onBlur={this.handleUpdate}
                          />
                        </td>
                        <td>
                          <input
                            type="text"
                            class="form-control stock_inp"
                            minLength="1"
                            maxLength="2"
                            defaultValue={subData.discount}
                            data-testname={
                              finalLoadedData.diagnosis_products_master_tbl
                                ? finalLoadedData.diagnosis_products_master_tbl
                                    .testname
                                : ""
                            }
                            onKeyPress={(event) => {
                              if (!/[0-9.]/.test(event.key)) {
                                event.preventDefault();
                              }
                            }}
                            id={
                              "discount_" +
                              subData.id +
                              "-" +
                              subData.medicine_id
                            }
                            onBlur={this.handleUpdate}
                          />
                        </td>
                        <td>
                          {/* <textarea
                            class="form-control col-md-4"
                            minLength="1"
                            maxLength="2"
                            defaultValue={
                              finalLoadedData.diagnosis_products_master_tbl
                                ? finalLoadedData.diagnosis_products_master_tbl
                                    .description
                                : ""
                            }
                            onKeyPress={(event) => {
                              if (!/[0-9.]/.test(event.key)) {
                                event.preventDefault();
                              }
                            }}
                            id={
                              "description_" +
                              subData.id +
                              "-" +
                              subData.medicine_id
                            }
                            onBlur={this.handleUpdate}
                          /> */}
                          {finalLoadedData.diagnosis_products_master_tbl
                            ? finalLoadedData.diagnosis_products_master_tbl
                                .description
                            : ""}{" "}
                        </td>
                        <td>
                          <a
                            href="#"
                            id={subData.id}
                            onClick={this.deleteproduct.bind(
                              this,
                              subData.id,
                              subData.medicine_id
                            )}
                          >
                            <img src="../images/retailer/delete.svg" />
                            Delete
                          </a>
                        </td>
                      </tr>
                    </React.Fragment>
                  );
                })
              : ""}
          </React.Fragment>
        );
      }
    );
    this.setState({ exportproductsarray: exportproductsarray });
    return retailerCurrentMedicineDetailsView;
  }

  // Retailer Expire stock Prodcuts List
  retailerExpiredStockProductsList = (retailerId) => {
    Httpconfig.httptokenget(
      Constant.siteurl +
        "api/DIAGNOSIS/diagnosisProduct/retailer/expiryStock/" +
        retailerId,
      {}
    )
      .then((response) => {
        if (response.status == 200) {
          if (Object.keys(response.data.data).length > 0) {
            const retailerExpireStockCurrentMedicineDetailsView = response.data.data.map(
              (finalLoadedData, num) => {
                return (
                  <React.Fragment>
                    {Object.keys(finalLoadedData.dignostic_stock_tbls).length >
                    0
                      ? finalLoadedData.dignostic_stock_tbls.map(
                          (subData, num) => {
                            return (
                              <React.Fragment>
                                <tr class="stock_row">
                                  {num == 0 ? (
                                    <td rowspan={num == 1 ? "2" : ""}>
                                      {
                                        finalLoadedData
                                          .diagnosis_products_master_tbl
                                          .testname
                                      }{" "}
                                      <h6>
                                        {
                                          finalLoadedData
                                            .diagnosis_products_master_tbl
                                            .manufacturer
                                        }
                                      </h6>
                                    </td>
                                  ) : (
                                    <td rowspan=""> </td>
                                  )}
                                  <td>
                                    <p>{subData.batch}</p>
                                  </td>
                                  <td>
                                    <p>
                                      {dateformatter.asianDateFormat(
                                        subData.expiry_date
                                      )}
                                    </p>
                                  </td>
                                  <td>
                                    <p>{subData.hsn ? subData.hsn : "---"}</p>
                                  </td>
                                  <td>
                                    <p>
                                      {subData.quantity} Strips{" "}
                                      {subData.quantity < 5 ? (
                                        <img
                                          class="strip_down"
                                          src="../images/patient/img/arrow-back.svg"
                                        />
                                      ) : (
                                        ""
                                      )}
                                    </p>
                                  </td>
                                  <td>
                                    <p>₹ {subData.mrp}</p>
                                  </td>
                                </tr>
                              </React.Fragment>
                            );
                          }
                        )
                      : ""}
                  </React.Fragment>
                );
              }
            );
            this.state.retailerExpireStockCurrentMedicineDetailsView = retailerExpireStockCurrentMedicineDetailsView;
            this.forceUpdate();
          }
        }
      })
      .catch((error) => {
        toast.error(error);
      });
  };
  // Retailer out of stock products list
  retailerOutStockProductsList = (retailerId) => {
    Httpconfig.httptokenget(
      Constant.siteurl +
        "api/DIAGNOSIS/diagnosisProduct/retailer/emptyStock/" +
        retailerId,
      {}
    )
      .then((response) => {
        if (response.status == 200) {
          if (Object.keys(response.data.data).length > 0) {
            const retailerOutStockCurrentMedicineDetailsView = response.data.data.map(
              (finalLoadedData, num) => {
                return (
                  <React.Fragment>
                    {Object.keys(finalLoadedData.dignostic_stock_tbls).length >
                    0
                      ? finalLoadedData.dignostic_stock_tbls.map(
                          (subData, num) => {
                            return (
                              <React.Fragment>
                                <tr class="stock_row">
                                  {num == 0 ? (
                                    <td rowspan={num == 1 ? "2" : ""}>
                                      {
                                        finalLoadedData
                                          .diagnosis_products_master_tbl
                                          .testname
                                      }{" "}
                                      <h6>
                                        {
                                          finalLoadedData
                                            .diagnosis_products_master_tbl
                                            .manufacturer
                                        }
                                      </h6>
                                    </td>
                                  ) : (
                                    <td rowspan=""> </td>
                                  )}
                                  <td>
                                    <p>{subData.batch}</p>
                                  </td>
                                  <td>
                                    <p>
                                      {dateformatter.asianDateFormat(
                                        subData.expiry_date
                                      )}
                                    </p>
                                  </td>
                                  <td>
                                    <p>{subData.hsn ? subData.hsn : "---"}</p>
                                  </td>
                                  <td>
                                    <p>
                                      {subData.quantity} Strips{" "}
                                      {subData.quantity < 5 ? (
                                        <img
                                          class="strip_down"
                                          src="../images/patient/img/arrow-back.svg"
                                        />
                                      ) : (
                                        ""
                                      )}
                                    </p>
                                  </td>
                                  <td>
                                    <p>₹ {subData.mrp}</p>
                                  </td>
                                  {num == 0 ? (
                                    <td
                                      rowspan={num == 1 ? "2" : ""}
                                      class="input_td"
                                    >
                                      <input
                                        type="checkbox"
                                        name={"med" + subData.id}
                                        id={
                                          subData.medicine_id +
                                          "," +
                                          "0" +
                                          "," +
                                          subData.id +
                                          ",out"
                                        }
                                        onChange={this.addShortage}
                                      />
                                    </td>
                                  ) : (
                                    <td></td>
                                  )}
                                  <td>
                                    <div class="dropdown">
                                      <img
                                        onclick="myFunction()"
                                        class="edit_icon "
                                        src="../images/retailer/dottedMenu.svg"
                                      />
                                      <div
                                        class="dropdown-menu"
                                        aria-labelledby="dropdownMenuButton"
                                      >
                                        <a
                                          href="#"
                                          id={subData.id}
                                          onClick={this.editproduct}
                                        >
                                          <img src="../images/retailer/edit.svg" />
                                          Edit
                                        </a>
                                        <a
                                          href="#"
                                          id={subData.medicine_id}
                                          onClick={this.deleteproduct}
                                        >
                                          <img src="../images/retailer/delete.svg" />
                                          Delete
                                        </a>
                                      </div>
                                    </div>
                                  </td>
                                </tr>
                              </React.Fragment>
                            );
                          }
                        )
                      : ""}
                  </React.Fragment>
                );
              }
            );
            this.state.retailerNoStockCurrentMedicineDetailsView = retailerOutStockCurrentMedicineDetailsView;
            this.forceUpdate();
          }
        }
      })
      .catch((error) => {
        toast.error(error);
      });
  };
  // search products of retailer
  searchProduct = (event) => {
    let searchString = event.target.value;
    let retailerId = this.state.retailerId;
    let searchType = this.state.searchType;

    if (event.target.value === 0 && event.target.id != "") {
      searchString = event.target.id;
      $(".alpha-list").removeClass("active");
      $("#" + searchString).addClass("active");
    }
    if (searchString != "") {
      Httpconfig.httptokenpost(
        Constant.siteurl + "api/DIAGNOSIS/diagnosisProduct/search",
        {
          retailerId: retailerId,
          search_type: searchType,
          testname: searchString,
        }
      )
        .then((response) => {
          if (response.status == 200) {
            if (Object.keys(response.data.data).length > 0) {
              let exportproductsarray = [];

              const retailerCurrentMedicineDetailsView = response.data.data.map(
                (finalLoadedData, num) => {
                  return (
                    <React.Fragment>
                      {Object.keys(finalLoadedData.dignostic_stock_tbls)
                        .length > 0
                        ? finalLoadedData.dignostic_stock_tbls.map(
                            (subData, num1) => {
                              exportproductsarray.push({
                                test_id: finalLoadedData.id,
                                testname: finalLoadedData.testname
                                  ? finalLoadedData.testname
                                  : "",
                                test_type: finalLoadedData.test_type
                                  ? finalLoadedData.test_type
                                  : "",

                                discount: subData.discount,
                                mrp: subData.mrp,
                                description: subData.description,

                                // GST:
                                //   this.state.retailerDetails["gst_type"] ==
                                //   "GST"
                                //     ? parseFloat(subData.CGST) +
                                //       parseFloat(subData.SGST)
                                //     : parseFloat(subData.IGST),
                                productId: subData.product_id,
                              });
                              return (
                                <React.Fragment>
                                  <tr class="stock_row">
                                    {num1 == 0 ? (
                                      <td rowspan={num1 == 1 ? "2" : ""}>
                                        {finalLoadedData.testname
                                          ? finalLoadedData.testname
                                          : ""}{" "}
                                        <h6>
                                          {finalLoadedData.manufacturer
                                            ? finalLoadedData.manufacturer
                                            : ""}
                                        </h6>
                                      </td>
                                    ) : (
                                      <td rowspan=""></td>
                                    )}

                                    {/* <td>
                                      {this.state.retailerDetails["gst_type"] ==
                                      "GST" ? (
                                        <input
                                          type="text"
                                          class="form-control stock_inp"
                                          defaultValue={
                                            parseFloat(subData.CGST) +
                                            parseFloat(subData.SGST)
                                          }
                                          id={
                                            "vat_" +
                                            subData.id +
                                            "-" +
                                            subData.medicine_id
                                          }
                                          onBlur={this.handleUpdate}
                                        />
                                      ) : (
                                        <input
                                          type="text"
                                          class="form-control stock_inp"
                                          defaultValue={parseFloat(
                                            subData.IGST
                                          )}
                                          id={
                                            "vat_" +
                                            subData.id +
                                            "-" +
                                            subData.medicine_id
                                          }
                                          onBlur={this.handleUpdate}
                                        />
                                      )}
                                    </td> */}

                                    <td>
                                      <input
                                        type="text"
                                        class="form-control stock_inp"
                                        defaultValue={subData.mrp}
                                        id={
                                          "mrp_" +
                                          subData.id +
                                          "-" +
                                          subData.medicine_id
                                        }
                                        onBlur={this.handleUpdate}
                                      />
                                    </td>
                                    <td>
                                      <input
                                        type="text"
                                        class="form-control stock_inp"
                                        defaultValue={subData.discount}
                                        id={
                                          "discount_" +
                                          subData.id +
                                          "-" +
                                          subData.medicine_id
                                        }
                                        onBlur={this.handleUpdate}
                                      />
                                    </td>
                                    <td>
                                      {finalLoadedData.description
                                        ? finalLoadedData.description
                                        : ""}{" "}
                                    </td>
                                    <td>
                                      <div class="dropdown">
                                        <img
                                          onclick="myFunction()"
                                          class="edit_icon "
                                          src="../images/retailer/dottedMenu.svg"
                                        />
                                        <div
                                          class="dropdown-menu"
                                          aria-labelledby="dropdownMenuButton"
                                        >
                                          {/* <a
                                            href="#"
                                            id={
                                              finalLoadedData
                                                ? finalLoadedData.id
                                                : ""
                                            }
                                            onClick={this.getProductDetailsbyId}
                                          >
                                            <img src="../images/retailer/addNewbatch.svg" />
                                            Add Batch
                                          </a> */}
                                          <a
                                            href="#"
                                            id={subData.id}
                                            onClick={this.deleteproduct.bind(
                                              this,
                                              subData.id,
                                              subData.medicine_id
                                            )}
                                          >
                                            <img src="../images/retailer/delete.svg" />
                                            Delete
                                          </a>
                                        </div>
                                      </div>
                                    </td>
                                  </tr>
                                </React.Fragment>
                              );
                            }
                          )
                        : ""}
                    </React.Fragment>
                  );
                }
              );

              if (this.state.availableHome == "nav-item nav-link active") {
                this.setState({
                  retailerCurrentMedicineDetailsView: [],
                });
                this.state.retailerCurrentMedicineDetailsView = retailerCurrentMedicineDetailsView;
              }
              if (this.state.runningHome == "nav-item nav-link active") {
                this.setState({
                  retailerLowStockCurrentMedicineDetailsView: [],
                });
                this.state.retailerLowStockCurrentMedicineDetailsView = retailerCurrentMedicineDetailsView;
              }
              if (this.state.expireHome == "nav-item nav-link active") {
                this.setState({
                  retailerExpireStockCurrentMedicineDetailsView: [],
                });
                this.state.retailerExpireStockCurrentMedicineDetailsView = retailerCurrentMedicineDetailsView;
              }
              if (this.state.outHome == "nav-item nav-link active") {
                this.setState({
                  retailerOutStockCurrentMedicineDetailsView: [],
                });
                this.state.retailerOutStockCurrentMedicineDetailsView = retailerCurrentMedicineDetailsView;
              }

              this.state.exportproductsarray = exportproductsarray;
              this.forceUpdate();
            } else {
              if (this.state.availableHome == "nav-item nav-link active") {
                this.state.retailerCurrentMedicineDetailsView =
                  "No Results found";
                this.forceUpdate();
              }
              if (this.state.runningHome == "nav-item nav-link active") {
                this.state.retailerLowStockCurrentMedicineDetailsView =
                  "No Results found";
                this.forceUpdate();
              }
              if (this.state.expireHome == "nav-item nav-link active") {
                this.state.retailerExpireStockCurrentMedicineDetailsView =
                  "No Results found";
                this.forceUpdate();
              }
              if (this.state.outHome == "nav-item nav-link active") {
                this.state.retailerOutStockCurrentMedicineDetailsView =
                  "No Results found";
                this.forceUpdate();
              }
            }
          }
        })
        .catch((error) => {
          toast.error(error);
        });
    } else {
      if (this.state.availableHome == "nav-item nav-link active") {
        this.retailerProductsList(retailerId);
      }
      if (this.state.runningHome == "nav-item nav-link active") {
        this.retailerLowStockProductsList(retailerId);
      }
      if (this.state.expireHome == "nav-item nav-link active") {
        this.retailerExpiredStockProductsList(retailerId);
      }
      if (this.state.outHome == "nav-item nav-link active") {
        this.retailerOutStockProductsList(retailerId);
      }
    }
  };
  //  For show upload
  showUpload = () => {
    window.location.href = "./Retaileruploadstock";
  };
  // delete products stock

  deleteproduct = (productId, testId) => {
    let retailerId = this.state.retailerId;
    Httpconfig.httptokendelete(
      Constant.siteurl +
        "api/DIAGNOSIS/diagnosisProduct/" +
        retailerId +
        "/" +
        testId +
        "/" +
        productId,
      {}
    )
      .then((response) => {
        if ((response.data.status = 200)) {
          this.getAllDashboardDetails(retailerId);
          toast.success("Diagnostic test is deleted successfully");
          if (this.state.availableHome == "nav-item nav-link active") {
            this.retailerProductsList(retailerId);
          }
          if (this.state.runningHome == "nav-item nav-link active") {
            this.retailerLowStockProductsList(retailerId);
          }
          if (this.state.expireHome == "nav-item nav-link active") {
            this.retailerExpiredStockProductsList(retailerId);
          }
          if (this.state.outHome == "nav-item nav-link active") {
            this.retailerOutStockProductsList(retailerId);
          }
        }
      })
      .catch((error) => {
        toast.error(error);
      });
  };
  // Add medinces to Shortage book
  addShortage = (event) => {
    let retailerId = this.state.retailerId;
    let data = event.currentTarget.id;
    let result = data.split(",");
    let testId = result[0];
    let id = result[2];
    let qty = result[1];
    if (document.getElementById(event.currentTarget.id).checked == true) {
      Httpconfig.httptokenpost(
        Constant.siteurl +
          "api/DIAGNOSIS/diagnosisProduct/retailer/shortageBook",
        {
          retailer_id: retailerId,
          medicine_id: testId,
          quantity: qty,
        }
      )
        .then((response) => {
          if (response.data.status == 200) {
            toast.success(response.data.message);
            this.getAllDashboardDetails(retailerId);

            document.getElementById(data).checked = false;
          }
          if (response.data.status == 204) {
            toast.error(response.data.message);
            document.getElementById(data).checked = false;
          }
        })
        .catch((error) => {
          toast.error(error);
        });
    } else {
      Httpconfig.httptokendelete(
        Constant.siteurl +
          "api/DIAGNOSIS/diagnosisProduct/retailer/shortageBook/" +
          id
      )
        .then((response) => {
          if ((response.data.status = 200)) {
            toast.success(response.data.message);
          }
        })
        .catch((error) => {
          toast.error(error);
        });
    }
  };
  //  for retailerShortagebookProductsList
  retailerShortagebookProductsList = (retailerId) => {
    Httpconfig.httptokenget(
      Constant.siteurl +
        "api/DIAGNOSIS/diagnosisProduct/shortageBook/retailer/" +
        retailerId
    )
      .then((response) => {
        let orderallarray = [];
        if ((response.data.status = 200)) {
          let shortageBookItemsCount = Object.keys(response.data.data).length;
          if (Object.keys(response.data.data).length > 0) {
            const retailerStortagebookMedicineDetailsView = response.data.data.map(
              (finalLoadedData, num) => {
                orderallarray.push({
                  orderquantity:
                    finalLoadedData.diagnosis_products_master_tbl.id,
                });
                return (
                  <tr>
                    <td>
                      {finalLoadedData.diagnosis_products_master_tbl.testname}{" "}
                      <h6>
                        {
                          finalLoadedData.diagnosis_products_master_tbl
                            .manufacturer
                        }
                      </h6>
                    </td>
                    <td>
                      <div class="qty">
                        <span
                          class="minus bg-dark"
                          id={
                            finalLoadedData.id +
                            "-" +
                            finalLoadedData.diagnosis_products_master_tbl.id
                          }
                          onClick={this.qtyDecrement}
                        >
                          -
                        </span>
                        <input
                          type="number"
                          class="count"
                          name="qty"
                          value={
                            finalLoadedData.quantity
                              ? finalLoadedData.quantity
                              : "0"
                          }
                          id={
                            "txt-" +
                            finalLoadedData.diagnosis_products_master_tbl.id
                          }
                          onKeyUp={this.updateQty}
                        />
                        <span
                          class="plus bg-dark"
                          id={
                            finalLoadedData.id +
                            "-" +
                            finalLoadedData.diagnosis_products_master_tbl.id
                          }
                          onClick={this.qtyIncrement}
                        >
                          +
                        </span>
                      </div>
                    </td>
                    <td>
                      <input
                        type="checkbox"
                        class="add_one"
                        name={finalLoadedData.diagnosis_products_master_tbl.id}
                        id={
                          "shrt-" +
                          finalLoadedData.diagnosis_products_master_tbl.id
                        }
                        onChange={this.addFinalList}
                      />{" "}
                      Add
                    </td>
                    <td
                      class="delete_txt"
                      onClick={this.deleteShortageBook.bind(
                        this,
                        finalLoadedData.medicine_id
                      )}
                    >
                      <img
                        src="../images/retailer/RedDeleteMedicine.svg"
                        id={finalLoadedData.medicine_id}
                      />{" "}
                      Delete
                    </td>
                  </tr>
                );
              }
            );
            this.state.retailerShortagebookProductsList = retailerStortagebookMedicineDetailsView;
            this.state.shortageBookItemsCount = shortageBookItemsCount;
            this.state.showFinalOrderButton = "total_items collapse-show";
            this.state.orderallarray = orderallarray;
            this.forceUpdate();
          } else {
            this.state.retailerShortagebookProductsList = "";
            this.state.shortageBookItemsCount = "0";
            this.state.showFinalOrderButton = "total_items collapse-hide";
            this.forceUpdate();
          }
        }
      })
      .catch((error) => {
        toast.error(error);
      });
  };

  // shortage book quanatity decrement

  qtyDecrement = (event) => {
    let data = event.currentTarget.id.split("-");
    let id = data[0];
    let testId = data[1];
    let qty = $("#txt-" + testId).val();

    if (qty > 0) {
      qty = qty - 1;
      $("#txt-" + testId).val(qty);
      this.updateShortagebookQuantity(id, testId, qty);
    }
  };

  // shortage book quanatity Increment
  qtyIncrement = (event) => {
    let data = event.currentTarget.id.split("-");
    let id = data[0];
    let testId = data[1];
    let qty = $("#txt-" + testId).val();

    if (qty >= 0) {
      qty = parseInt(qty) + 1;
      $("#txt-" + testId).val(qty);
      this.updateShortagebookQuantity(id, testId, qty);
    }
  };

  // shortage book quanatity enter
  updateQty = (event) => {
    let data = event.currentTarget.id.split("-");
    let id = data[1];
    let qty = event.target.value;
  };

  // add shortage book to final order list

  addFinalList = (event) => {
    let data = event.currentTarget.id.split("-");
    let id = data[1];
    if (document.getElementById(event.currentTarget.id).checked == true) {
      let qty = $("#txt-" + id).val();
      if (qty == 0) {
        document.getElementById(event.currentTarget.id).checked = false;
        toast.error("Quantity should not be zero");
      } else {
        this.updateFinalOrder(id, qty);
      }
    } else {
    }
  };

  // add/update to theShortage book list
  updateShortagebookQuantity = (id, testid, qty) => {
    let retailerId = this.state.retailerId;
    Httpconfig.httptokenput(
      Constant.siteurl +
        "api/DIAGNOSIS/diagnosisProduct/retailer/shortageBook/" +
        id,
      {
        retailer_id: retailerId,
        testid: testid,
        quantity: qty,
      }
    )
      .then((response) => {
        if ((response.data.status = 200)) {
        }
      })
      .catch((error) => {
        toast.error(error);
      });
  };

  // add/update to the final order list
  updateFinalOrder = (testid, qty) => {
    let retailerId = this.state.retailerId;
    Httpconfig.httptokenpost(
      Constant.siteurl + "api/DIAGNOSIS/diagnosisProduct/retailer/finalorder",
      {
        finalorder: [
          {
            retailer_id: retailerId,
            medicine_id: testid,
            quantity: qty,
          },
        ],
      }
    )
      .then((response) => {
        if ((response.data.status = 200)) {
        }
      })
      .catch((error) => {
        toast.error(error);
      });
  };

  // delte item from shortage book

  deleteShortageBook = (id) => {
    Httpconfig.httptokendelete(
      Constant.siteurl +
        "api/DIAGNOSIS/diagnosisProduct/retailer/shortageBook/" +
        this.state.retailerId +
        "/" +
        id
    )
      .then((response) => {
        if ((response.data.status = 200)) {
          this.retailerShortagebookProductsList(this.state.retailerId);
          this.getAllDashboardDetails(this.state.retailerId);
          toast.success(response.data.message);
        }
      })
      .catch((error) => {
        toast.error(error);
      });
  };

  //Order all products to shortage book

  orderAllShortageBook = (event) => {
    var Totqty = this.state.orderallarray;
    var errorCount = 0;
    if (Object.keys(Totqty).length > 0) {
      for (var qty = 0; qty < Object.keys(Totqty).length; qty++) {
        let id = Totqty[qty].orderquantity;
        let allQty = $("#txt-" + id).val();

        if (allQty == 0) {
          errorCount++;
        }
      }
      if (errorCount > 0) {
        toast.error("order all quantity should not be zero");
        document.getElementById(event.currentTarget.id).checked = false;
        return false;
      } else {
        $(".add_one").prop("checked", true);
      }
    }

    if (document.getElementById(event.currentTarget.id).checked == true) {
      Httpconfig.httptokenpost(
        Constant.siteurl +
          "api/DIAGNOSIS/diagnosisProduct/shortageBook/orderAll/retailer",
        {
          retailer_id: this.state.retailerId,
        }
      )
        .then((response) => {
          if ((response.data.status = 200)) {
            toast.success(response.data.message);
          }
        })
        .catch((error) => {
          toast.error(error);
        });
    } else {
      Httpconfig.httptokendelete(
        Constant.siteurl +
          "api/DIAGNOSIS/diagnosisProduct/deleteAllShortageBookFinalOrder/" +
          this.state.retailerId
      )
        .then((response) => {
          if ((response.data.status = 200)) {
            this.retailerShortagebookProductsList(this.state.retailerId);
            toast.success(response.data.message);
          }
        })
        .catch((error) => {
          toast.error(error);
        });
    }
  };

  // delete all items in the shortage book

  deleteAllShortageBook = () => {
    Httpconfig.httptokendelete(
      Constant.siteurl +
        "api/DIAGNOSIS/diagnosisProduct/deleteAllShortageBookFinalOrder/" +
        this.state.retailerId
    )
      .then((response) => {
        if ((response.data.status = 200)) {
          this.retailerShortagebookProductsList(this.state.retailerId);
          toast.success(response.data.message);
        }
      })
      .catch((error) => {
        toast.error(error);
      });
  };

  // print shortage book div

  printDiv = () => {
    var printContents = document.getElementById("final_ord_details").innerHTML;
    var originalContents = document.body.innerHTML;
    document.body.innerHTML = printContents;
    window.print();
    document.body.innerHTML = originalContents;
  };

  // add Product request
  addProductRequest = () => {
    let fields = this.state.fields;
    let errors = {};
    let formIsValid = true;

    if (!fields["MRP"]) {
      errors["MRP"] = "";
      formIsValid = false;
      errors["MRP"] = "Enter MRP";
    }
    if (!fields["MRP"]) {
      errors["MRP"] = "";
      formIsValid = false;
      errors["MRP"] = "Enter MRP";
    }
    if (!fields["DISCOUNT"]) {
      errors["DISCOUNT"] = "";
      formIsValid = false;
      errors["DISCOUNT"] = "Enter Discount";
    }
    if (!fields["TEST_TYPE"]) {
      errors["TEST_TYPE"] = "";
      formIsValid = false;
      errors["TEST_TYPE"] = "Select Test Type";
    }

    // Validate package tests if test type is package
    if (
      fields["TEST_TYPE"] === "package" &&
      this.state.selectedPackageTests.length === 0
    ) {
      errors["PACKAGE_TESTS"] = "";
      formIsValid = false;
      errors["PACKAGE_TESTS"] =
        "Please select at least one test for the package";
    }

    this.setState({ errors: errors });
    if (formIsValid == true) {
      // Prepare test_ids array for package
      let testIds = [];
      if (
        fields["TEST_TYPE"] === "package" &&
        this.state.selectedPackageTests.length > 0
      ) {
        testIds = this.state.selectedPackageTests.map((test) => test.id);
      }

      Httpconfig.httptokenpost(
        Constant.siteurl + "api/DIAGNOSIS/request/productRequest",
        {
          clinic_id: null,
          medicineid: null,
          medicine_name: this.state.search,
          mrp: fields["MRP"],
          discount: fields["DISCOUNT"],
          test_type: fields["TEST_TYPE"],
          description: fields["test_description"],
          compositions: "",
          retailer: this.state.retailerId,
          test_ids: testIds, // Send array of test IDs for package
        }
      )
        .then((response) => {
          if ((response.data.status = 200)) {
            this.state.search = "";
            this.clearAll();

            toast.success(response.data.message);
          }
        })
        .catch((error) => {
          toast.error(error);
        });
    } else {
      toast.error("forms has erros");
    }
  };

  handleUpdate = (event, gstType) => {
    this.forceUpdate();
    let postObj = {};
    let clickedId = event.currentTarget.id;
    let ids = clickedId.split("_");
    if (ids[0] == "batch") {
      postObj.batch = event.currentTarget.value;
    } else if (ids[0] == "expirydate") {
      postObj.expiry_date = event.currentTarget.value;
    } else if (ids[0] == "vat") {
      let gstType = this.state.retailerDetails["gst_type"];
      if (gstType == "GST") {
        let GST = Number(event.currentTarget.value) / 2;
        postObj.SGST = GST;
        postObj.CGST = GST;
      } else {
        postObj.IGST = event.currentTarget.value;
      }
    } else if (ids[0] == "quantity") {
      postObj.quantity = event.currentTarget.value;
    } else if (ids[0] == "mrp") {
      postObj.mrp = event.currentTarget.value;
    } else if (ids[0] == "discount") {
      postObj.discount = event.currentTarget.value;
    }

    let idData = ids[1].split("-");
    let testId = idData[1];
    let id = idData[0];
    postObj.retailer_id = this.state.retailerId;
    postObj.medicine_id = testId;
    // capture which field was updated and the test name from DOM
    const fieldType = ids[0];
    const testName =
      event.currentTarget.getAttribute("data-testname") || "Test";

    Httpconfig.httptokenput(
      Constant.siteurl + "api/DIAGNOSIS/diagnosisProduct/stock/" + id,
      postObj
    )
      .then((response) => {
        if ((response.data.status = 200 && !response.data.error)) {
          // Show contextual toast for price or discount updates
          if (fieldType === "mrp") {
            toast.success(`Price updated for ${testName}`);
          } else if (fieldType === "discount") {
            toast.success(`Discount updated for ${testName}`);
          } else {
            toast.success(response.data.message);
          }
        } else {
          event.currentTarget.value = 10;
          toast.error(response.data.message);
        }
      })
      .catch((error) => {
        toast.error(error);
      });
  };

  //  for get Product Details by Id

  getProductDetailsbyId = (event) => {
    let testId = event.currentTarget.id;
    this.state.selelcteTestId = testId;
    if (testId != "") {
      Httpconfig.httptokenget(
        Constant.siteurl + "api/DIAGNOSIS/diagnosisProduct/" + testId
      )
        .then((response) => {
          if ((response.data.status = 200)) {
            this.showAddMedicine();

            let testName =
              response.data.data[0].diagnosis_products_master_tbl.testname;
            let manufacturer =
              response.data.data[0].diagnosis_products_master_tbl.manufacturer;
            let form = response.data.data[0].diagnosis_products_master_tbl.form;
            $("#medicineList").val(
              testName + " | " + form + " | " + manufacturer
            );
          }
        })
        .catch((error) => {
          toast.error(error);
        });
    }
  };

  //  For select all
  handleAll = (event) => {
    let searchString = event.currentTarget.id;
    $(".alpha-list").removeClass("active");
    $("#" + searchString).addClass("active");
    this.retailerProductsList(this.state.retailerId);
  };
  render() {
    return (
      <main id="main">
        <DiagnosisHeader />
        <DiagnosisMenu />
        <section id="Pharmacy_dashboard">
          <div class="container-fluid">
            <div class="row">
              <div class="col-lg-10 col-md-10 Pharma_Content">
                <section class="manage_section">
                  <div class="container-fluid">
                    <div class="row">
                      <div class="col-md-12">
                        <nav class="p_nav">
                          <div
                            class="nav nav-tabs nav-fill"
                            id="nav-tab"
                            role="tablist"
                          >
                            <a
                              class={this.state.availableHome}
                              id="available_home-tab"
                              data-toggle="tab"
                              href="#available_home"
                              role="tab"
                              aria-controls="available-home"
                              aria-selected="true"
                              onClick={this.handleClick}
                            >
                              Available Tests
                              <p>{this.state.totalAvailableStock}</p>
                            </a>

                            <div class="add_med_btn">
                              <a href="#">
                                <button
                                  type="button"
                                  onClick={this.showAddMedicine}
                                >
                                  {" "}
                                  <img src="../images/retailer/testicon.svg" />{" "}
                                  Add New Test
                                </button>
                              </a>
                            </div>
                            {/* <div class="add_agent_btn">
                              <a href="/diagnostics/Viewagents">
                                {" "}
                                <img src="../images/retailer/AddNewMedicine.svg" />{" "}
                                Add New Agent
                              </a>
                            </div> */}
                          </div>
                        </nav>
                        <div
                          id="bottom-section"
                          class={this.state.otherSection}
                        >
                          <div class="row">
                            <div class="col-md-12">
                              <div class="manage_search">
                                <div
                                  class={this.state.searchInput}
                                  id="search_input"
                                >
                                  <input
                                    type="text"
                                    class="form-control"
                                    placeholder="Search test by name"
                                    onKeyUp={this.searchProduct}
                                  />
                                  <div class="input-group-btn">
                                    <div class="btn-group" role="group">
                                      <button class="btn btn-default">
                                        <img src="../images/retailer/search.svg" />
                                      </button>
                                    </div>
                                  </div>
                                </div>
                                <div class={this.state.searchDownload}>
                                  <ExcelFile
                                    filename="Diagnostics download"
                                    element={
                                      <a href="#">
                                        {" "}
                                        <p>
                                          <img src="../images/retailer/downloadicon.svg" />
                                          Download Tests XLS
                                        </p>
                                      </a>
                                    }
                                  >
                                    <ExcelSheet
                                      data={this.state.exportproductsarray}
                                      name="Order Request"
                                    >
                                      <ExcelColumn label="Id" value="test_id" />
                                      <ExcelColumn
                                        label="Test Name"
                                        value="testname"
                                      />

                                      <ExcelColumn
                                        label="Test Type"
                                        value="test_type"
                                      />

                                      <ExcelColumn
                                        label="Discount"
                                        value="discount"
                                      />
                                      <ExcelColumn label="MRP" value="mrp" />

                                      <ExcelColumn
                                        label="description"
                                        value="description"
                                      />
                                    </ExcelSheet>
                                  </ExcelFile>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div class="row">
                            <div class="col-md-12">
                              <div
                                class="tab-content tab_side"
                                id="nav-tabContent"
                              >
                                <div
                                  class="tab-pane fade show active"
                                  id="available_home"
                                  role="tabpanel"
                                  aria-labelledby="available_home-tab"
                                >
                                  <div class="container-fluid">
                                    <div class="row stock_body">
                                      <div class="col-md-1 no_padding">
                                        <div class="index_box">
                                          <div class="index_head">
                                            <h2>Index</h2>
                                          </div>
                                          <ul>
                                            <li
                                              class="alpha-list active"
                                              id="all"
                                              onClick={this.handleAll}
                                            >
                                              All
                                            </li>

                                            <li id="available_home-li">
                                              {this.state.alphabetLists}
                                            </li>
                                          </ul>
                                        </div>
                                      </div>

                                      <div class="col-md-11 no_padding">
                                        <div class="table-responsive">
                                          <table>
                                            <thead>
                                              <tr>
                                                <th>Test name</th>
                                                {/* {this.state.retailerDetails[
                                                  "gst_type"
                                                ] == "GST" ? (
                                                  <th>GST(CGST + SGST)</th>
                                                ) : (
                                                  <th>GST</th>
                                                )} */}
                                                <th>Price</th>
                                                <th>Discount</th>
                                                <th>Description</th>
                                                <th></th>
                                              </tr>
                                            </thead>
                                            <tbody>
                                              {
                                                this.state
                                                  .retailerCurrentMedicineDetailsView
                                              }
                                            </tbody>
                                          </table>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                                <div
                                  class="tab-pane fade"
                                  id="running_home"
                                  role="tabpanel"
                                  aria-labelledby="running_home-tab"
                                >
                                  <div class="container-fluid">
                                    <div class="row  stock_body">
                                      <div class="col-md-1 no_padding">
                                        <div class="index_box">
                                          <div class="index_head">
                                            <h2>Index</h2>
                                          </div>
                                          <ul>
                                            <li class="active">All</li>
                                            <li id="running_home-li">
                                              {this.state.alphabetLists}
                                            </li>
                                          </ul>
                                        </div>
                                      </div>
                                      <div class="col-md-11 no_padding">
                                        <div class="table-responsive">
                                          <table>
                                            <thead>
                                              <tr>
                                                <th>Customer</th>
                                                <th>Batch</th>
                                                <th>Expiry Date</th>
                                                <th>GST</th>
                                                <th>Current Stock</th>
                                                <th>Price</th>
                                                <th class="input_td">
                                                  Reorder
                                                </th>
                                                <th></th>
                                              </tr>
                                            </thead>
                                            <tbody>
                                              {this.state
                                                .retailerLowStockCurrentMedicineDetailsView ? (
                                                this.state
                                                  .retailerLowStockCurrentMedicineDetailsView
                                              ) : (
                                                <React.Fragment>
                                                  <td></td>
                                                  <td></td>
                                                  <td></td>
                                                  <td>No Products</td>
                                                  <td></td>
                                                  <td></td>
                                                  <td></td>
                                                  <td></td>
                                                </React.Fragment>
                                              )}
                                            </tbody>
                                          </table>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                                <div
                                  class="tab-pane fade"
                                  id="out_home"
                                  role="tabpanel"
                                  aria-labelledby="out_home-tab"
                                >
                                  <div class="container-fluid">
                                    <div class="row  stock_body">
                                      <div class="col-md-1 no_padding">
                                        <div class="index_box">
                                          <div class="index_head">
                                            <h2>Index</h2>
                                          </div>
                                          <ul>
                                            <li class="active">All</li>
                                            <li id="out_home-li">
                                              {this.state.alphabetLists}
                                            </li>
                                          </ul>
                                        </div>
                                      </div>
                                      <div class="col-md-11 no_padding">
                                        <div class="table-responsive">
                                          <table>
                                            <thead>
                                              <tr>
                                                <th>Customer</th>
                                                <th>Batch</th>
                                                <th>Expiry Date</th>
                                                <th>GST</th>
                                                <th>Current Stock</th>
                                                <th>Price</th>
                                                <th>Reorder</th>
                                                <th></th>
                                              </tr>
                                            </thead>
                                            <tbody>
                                              {this.state
                                                .retailerNoStockCurrentMedicineDetailsView
                                                ? this.state
                                                    .retailerNoStockCurrentMedicineDetailsView
                                                : " No results found"}
                                            </tbody>
                                          </table>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                                <div
                                  class="tab-pane fade"
                                  id="expire_home"
                                  role="tabpanel"
                                  aria-labelledby="order_home-tab"
                                >
                                  <div class="container-fluid">
                                    <div class="row  stock_body">
                                      <div class="col-md-1 no_padding">
                                        <div class="index_box">
                                          <div class="index_head">
                                            <h2>Index</h2>
                                          </div>
                                          <ul>
                                            <li class="active">All</li>
                                            <li id="Expire_home-li">
                                              {this.state.alphabetLists}
                                            </li>
                                          </ul>
                                        </div>
                                      </div>
                                      <div class="col-md-11 no_padding">
                                        <div class="table-responsive">
                                          <table>
                                            <thead>
                                              <tr>
                                                <th>Customer</th>
                                                <th>Batch</th>
                                                <th>Expiry Date</th>
                                                <th>GST</th>
                                                <th>Current Stock</th>
                                                <th>Price</th>
                                                <th></th>
                                              </tr>
                                            </thead>
                                            <tbody>
                                              {this.state
                                                .retailerExpireStockCurrentMedicineDetailsView !=
                                              ""
                                                ? this.state
                                                    .retailerExpireStockCurrentMedicineDetailsView
                                                : "No results found "}
                                            </tbody>
                                          </table>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                                <div
                                  class="tab-pane fade"
                                  id="order_home"
                                  role="tabpanel"
                                  aria-labelledby="order_home-tab"
                                >
                                  <div class="container-fluid">
                                    <div class="row  stock_body">
                                      <div class="col-md-1 no_padding">
                                        <div class="index_box">
                                          <div class="index_head">
                                            <h2>Index</h2>
                                          </div>
                                          <ul>
                                            <li class="active">All</li>
                                            <li id="order_home-li">
                                              {this.state.alphabetLists}
                                            </li>
                                          </ul>
                                        </div>
                                      </div>
                                      <div class="col-md-11 no_padding">
                                        <div class="table-responsive">
                                          <table>
                                            <thead>
                                              <tr>
                                                <th>Medicine</th>
                                                <th>Add Quantity</th>
                                                <th class="order_all">
                                                  <input
                                                    type="checkbox"
                                                    id="orderAll"
                                                    onChange={
                                                      this.orderAllShortageBook
                                                    }
                                                  />
                                                  Order All
                                                </th>
                                                <th class="delete_head">
                                                  <img
                                                    src="../images/retailer/deleteAll.svg"
                                                    onClick={
                                                      this.deleteAllShortageBook
                                                    }
                                                  />{" "}
                                                  Delete All
                                                </th>
                                              </tr>
                                            </thead>
                                            <tbody>
                                              {
                                                this.state
                                                  .retailerShortagebookProductsList
                                              }
                                            </tbody>
                                          </table>
                                          <div
                                            class={
                                              this.state.showFinalOrderButton
                                            }
                                          >
                                            <p>
                                              Total{" "}
                                              {
                                                this.state
                                                  .shortageBookItemsCount
                                              }{" "}
                                              items added{" "}
                                              <h5 onClick={this.previewOrder}>
                                                <img src="../images/retailer/finalOrder.svg" />{" "}
                                                Final Order
                                              </h5>
                                            </p>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </section>

                <section
                  id="add_medicine"
                  class={this.state.addMedicineSection}
                >
                  <form
                    onSubmit={this.checkAddMedicineSubmit.bind(this)}
                    id="addMedicines"
                  >
                    <div class="add_med_content">
                      <div class="container">
                        <div class="row">
                          <div class="col-md-12">
                            <div class="add_med_head">
                              <h2>Add Test </h2>
                              <div class="upload_items">
                                <ExcelFile
                                  element={
                                    <a href="#">
                                      {" "}
                                      <p>
                                        <img src="../images/retailer/downloadicon.svg" />
                                        Download Tests XLS
                                      </p>
                                    </a>
                                  }
                                >
                                  <ExcelSheet
                                    data={this.state.exportproductsarray}
                                    name="Order Request"
                                  >
                                    <ExcelColumn
                                      label="Test ID"
                                      value="test_id"
                                    />
                                    <ExcelColumn
                                      label="Test Name"
                                      value="testname"
                                    />
                                    <ExcelColumn
                                      label="Product Type"
                                      value="product_type"
                                    />
                                    <ExcelColumn
                                      label="Test Type"
                                      value="test_type"
                                    />

                                    <ExcelColumn
                                      label="Discount"
                                      value="discount"
                                    />
                                    <ExcelColumn label="MRP" value="mrp" />

                                    <ExcelColumn
                                      label="description"
                                      value="description"
                                    />
                                  </ExcelSheet>
                                </ExcelFile>
                              </div>
                              {/* <div class="upload_items">
                                <a href="#" onClick={this.showUpload}>
                                  <p>
                                    {" "}
                                    <img src="../images/retailer/uploadicon.svg" />
                                    Upload XLS
                                  </p>
                                </a>
                              </div> */}
                            </div>
                          </div>
                        </div>

                        <div class="add_med_form">
                          <div class="row">
                            <div class="col-md-12">
                              <div class="form-group add_group add_form product_field">
                                <input
                                  type="text"
                                  class="form-control "
                                  autocomplete="off"
                                  name="product_name"
                                  id="medicineList"
                                  placeholder="Test name"
                                  onKeyUp={this.fetchmedicinedata}
                                />
                                <img
                                  class="search_cross"
                                  src="https://www.flaticon.com/svg/static/icons/svg/59/59836.svg"
                                  onClick={this.clearSearch}
                                />
                                <ul id="searchResult">
                                  {this.state.medicineOptions}
                                </ul>
                              </div>
                              <span className="cRed">
                                {this.state.errors["product_name"]}
                              </span>
                            </div>
                            <div class="col-md-12">
                              <div class="form-group add_group col-md-12">
                                <textarea
                                  rows="6"
                                  cols="50"
                                  name="test_description"
                                  id="medicineList"
                                  class="col-md-12"
                                  placeholder="Description"
                                  onChange={this.handleChangeInput.bind(
                                    this,
                                    "test_description"
                                  )}
                                  value={
                                    this.state.fields.test_description
                                      ? this.state.fields.test_description
                                      : ""
                                  }
                                />
                              </div>

                              <span className="cRed">
                                {this.state.errors["test_description"]}
                              </span>
                            </div>
                            <div class={this.state.showfields}>
                              <div class="form-group add_group col-md-2">
                                <input
                                  type="number"
                                  class="form-control"
                                  name="mrp"
                                  id="mrp_textfield"
                                  step="0.00000001"
                                  min="0.00000001"
                                  placeholder="MRP"
                                  value={this.state.fields.mrp}
                                  onChange={this.handleChangeInput.bind(
                                    this,
                                    "mrp"
                                  )}
                                />
                                <div className="cRed">
                                  {this.state.errors["mrp"]}
                                </div>
                              </div>

                              <div class="form-group add_group col-md-2">
                                <input
                                  type="text"
                                  class="form-control"
                                  name="discount"
                                  id="discount_textfield"
                                  minlength="0"
                                  maxlength="2"
                                  placeholder="Discount"
                                  value={this.state.fields.discount}
                                  onKeyPress={(event) => {
                                    if (!/[0-9.]/.test(event.key)) {
                                      event.preventDefault();
                                    }
                                  }}
                                  onChange={this.handleChangeInput.bind(
                                    this,
                                    "discount"
                                  )}
                                />
                                <div className="cRed">
                                  {this.state.errors["discount"]}
                                </div>
                              </div>
                              {/* <div class="form-group add_group col-md-2">
                                <input
                                  type="number"
                                  class="form-control"
                                  name="GSTAmt"
                                  step="0.00000001"
                                  min="0"
                                  id="GSTAmt_textfield"
                                  placeholder="GSTAmt%"
                                  onChange={this.handleChangeInput.bind(
                                    this,
                                    "GSTAmt"
                                  )}
                                />
                                <div className="cRed">
                                  {this.state.errors["GSTAmt"]}
                                </div>
                              </div> */}
                            </div>
                          </div>
                        </div>

                        <div class={this.state.requestbtn}>
                          <div class="row">
                            <div class="form-group add_group col-md-4">
                              <input
                                type="number"
                                step="0.00000001"
                                min="0.00000001"
                                class="form-control"
                                name="mrp"
                                placeholder="MRP"
                                onChange={this.handleChangeInput.bind(
                                  this,
                                  "MRP"
                                )}
                              />
                              <div className="cRed">
                                {this.state.errors["MRP"]}
                              </div>
                            </div>

                            <div class="form-group add_group col-md-4">
                              <input
                                type="text"
                                class="form-control"
                                minLength="1"
                                maxLength="2"
                                onKeyPress={(event) => {
                                  if (!/[0-9.]/.test(event.key)) {
                                    event.preventDefault();
                                  }
                                }}
                                name="discount"
                                placeholder="Discount"
                                onChange={this.handleChangeInput.bind(
                                  this,
                                  "DISCOUNT"
                                )}
                              />

                              <div className="cRed">
                                {this.state.errors["DISCOUNT"]}
                              </div>
                            </div>

                            <div class="form-group add_group col-md-4">
                              <select
                                name="test_type"
                                onChange={this.handleChangeInput.bind(
                                  this,
                                  "TEST_TYPE"
                                )}
                                class="form-control"
                              >
                                <option value="">Select Type</option>
                                <option value="test">Test</option>
                                <option value="package">Package</option>
                              </select>

                              <div className="cRed">
                                {this.state.errors["TEST_TYPE"]}
                              </div>
                            </div>
                          </div>
                        </div>
                        <div class="row">
                          {/* Package Tests Multi-Select Dropdown */}
                          {this.state.showPackageTestsDropdown && (
                            <div class="row">
                              <div class="col-md-12">
                                <div class="form-group add_group">
                                  <label>Select Tests for Package:</label>
                                  <Multiselect
                                    options={this.state.packageTestsData}
                                    selectedValues={
                                      this.state.selectedPackageTests
                                    }
                                    onSelect={this.handlePackageTestsSelect}
                                    onRemove={this.handlePackageTestsRemove}
                                    onSearch={this.searchPackageTests}
                                    displayValue="testname"
                                    placeholder="Search and select tests to include in package"
                                    emptyRecordMsg="Test not found. Try searching with different keywords."
                                    showCheckbox={true}
                                    showArrow={false}
                                    closeOnSelect={false}
                                    avoidHighlightFirstOption={true}
                                    style={{
                                      chips: {
                                        background: "#007bff",
                                        fontSize: "14px",
                                        color: "#fff",
                                      },
                                      searchBox: {
                                        border: "1px solid #ced4da",
                                        borderRadius: "4px",
                                        padding: "6px 12px",
                                        fontSize: "14px",
                                      },
                                      inputField: {
                                        fontSize: "14px",
                                        color: "#333",
                                      },
                                      option: {
                                        fontSize: "14px",
                                        padding: "8px 12px",
                                        backgroundColor: "#fff",
                                        color: "#333",
                                      },
                                      optionContainer: {
                                        maxHeight: "200px",
                                        backgroundColor: "#fff",
                                      },
                                      multiselectContainer: {
                                        backgroundColor: "#fff",
                                      },
                                    }}
                                  />
                                  <small className="text-muted">
                                    Type to search for tests. Only individual
                                    tests can be added to packages.
                                  </small>
                                  <div className="cRed">
                                    {this.state.errors["PACKAGE_TESTS"]}
                                  </div>
                                </div>
                              </div>
                            </div>
                          )}
                        </div>

                        <div class="add_med_btns">
                          <div class="clear_btn">
                            <a href="#">
                              <button type="button" onClick={this.clearAll}>
                                Clear All
                              </button>
                            </a>
                          </div>
                          <div class={this.state.updatebtn}>
                            <a href="#">
                              {" "}
                              <button type="submit">Update</button>
                            </a>
                          </div>

                          <div class={this.state.requestbtn}>
                            <a href="#">
                              {" "}
                              <button
                                type="button"
                                onClick={this.addProductRequest}
                              >
                                Send Add Request
                              </button>
                            </a>
                          </div>
                        </div>
                      </div>
                    </div>
                  </form>
                </section>

                <section id="final_order" class={this.state.finalOrder}>
                  <div class="final_content">
                    <div class="container">
                      <div class="row">
                        <div class="col-md-12">
                          <div class="final_back">
                            <a href="#" onClick={this.showOrderBook}>
                              {" "}
                              <h2>
                                <img src="../images/retailer/back_arrow.svg" />
                                Back to Order Book
                              </h2>
                            </a>
                          </div>
                          <div class="final_head">
                            {/* <h2>Final Order list</h2> */}

                            <div class="final_ord_book">
                              <ExcelFile
                                filename="Final Order List"
                                element={
                                  <a href="#">
                                    {" "}
                                    <p>
                                      <img src="../images/retailer/downloadicon.svg" />
                                      Download XLS
                                    </p>
                                  </a>
                                }
                              >
                                <ExcelSheet
                                  data={this.state.finalorderarray}
                                  name="Order Request"
                                >
                                  <ExcelColumn label="Name" value="name" />
                                  <ExcelColumn
                                    label="Manufacturer"
                                    value="manufacturer"
                                  />
                                  <ExcelColumn
                                    label="Quantity"
                                    value="quantity"
                                  />
                                </ExcelSheet>
                              </ExcelFile>
                              <a href="#" onClick={this.printDiv}>
                                {" "}
                                <p>
                                  <img src="../images/retailer/print.svg" />{" "}
                                  Print
                                </p>
                              </a>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="row">
                        <div class="col-md-12">
                          <div class="final_ord_details" id="final_ord_details">
                            <h4>Final Order list</h4>
                            {this.state.retailerFinalOrderMedicineDetailsView}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </section>
              </div>
            </div>
          </div>
          <ToastContainer />
        </section>{" "}
        <Footer />
      </main>
    );
  }
}
